import { getCountKeySetDataUtil } from '../get-count-key'

export function updateCountSetDataUtil (set, value) {
  return {
    ...set,
    [getCountKeySetDataUtil(set)]: value
  }
}
